var React = require('react');

function LinkIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.86762 2.1054L1.47302 9.5L0.5 8.52698L7.8946 1.13238L8.86762 2.1054Z","fill":"#6E717F","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.16104 0.5H8.81197C9.19196 0.5 9.5 0.80804 9.5 1.18803V7.83896H8.12395V1.87605H2.16104V0.5Z","fill":"#6E717F","key":1})]);
}

LinkIcon.defaultProps = {"width":"10","height":"10","viewBox":"0 0 10 10","fill":"none"};

module.exports = LinkIcon;

LinkIcon.default = LinkIcon;
